export const formTypes = Object.freeze({
  LOGIN: "login",
  EMAIL: "email",
  PASSWORD: "password",
  SIGNUP: "signup"
});
